<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8203 3.10033C11.5711 2.76604 12.4285 2.76604 13.1793 3.10033C13.7027 3.33333 14.0805 3.76043 14.4088 4.22516C14.7343 4.68589 15.0924 5.30622 15.5282 6.06096L20.639 14.9133C21.0748 15.668 21.4329 16.2883 21.6692 16.8006C21.9075 17.3173 22.0885 17.858 22.0286 18.4277C21.9427 19.2451 21.514 19.9877 20.8491 20.4708C20.3856 20.8075 19.8268 20.9211 19.2602 20.9731C18.6984 21.0246 17.9821 21.0246 17.1106 21.0246H6.88896C6.01747 21.0246 5.30117 21.0246 4.73942 20.9731C4.17278 20.9211 3.614 20.8075 3.15055 20.4708C2.48563 19.9877 2.05693 19.2451 1.97102 18.4277C1.91114 17.858 2.09211 17.3173 2.33041 16.8006C2.56666 16.2883 2.92482 15.668 3.36057 14.9132L8.47142 6.06097C8.90715 5.30622 9.26529 4.68589 9.5908 4.22516C9.91914 3.76043 10.2969 3.33333 10.8203 3.10033ZM12 8.09961C12.497 8.09961 12.9 8.50255 12.9 8.99961V12.9996C12.9 13.4967 12.497 13.8996 12 13.8996C11.5029 13.8996 11.1 13.4967 11.1 12.9996V8.99961C11.1 8.50255 11.5029 8.09961 12 8.09961ZM12.9998 16.4996C12.9998 17.0519 12.5521 17.4996 11.9998 17.4996C11.4476 17.4996 10.9998 17.0519 10.9998 16.4996C10.9998 15.9473 11.4476 15.4996 11.9998 15.4996C12.5521 15.4996 12.9998 15.9473 12.9998 16.4996Z" fill="#FF6363"/>
    </svg>
</template>

<script>
export default {
    name: 'exlamation-icon',
    props: {
        width: {
            type: [String, Number],
            default: 16,
        },
        height: {
            type: [String, Number],
            default: 16,
        },
        // Tailwind text color class, e.g. 'text-content-basic-3'
        color: {
            type: String,
            default: 'text-[#666666]',
        },
    },
};
</script>
